import { ProductTypeKey } from 'shared/types/product/Product';

// Env-overridable so a staging site can point PDPs at a staging builder without a code change,
// mirroring `customQuoteLink` (product-list/context/constants.ts) and `TREAD_BUILDER_BASE_URL`
// (helpers/treadBuilder.ts).
export const RAILING_BUILDER_URL = process.env.NEXT_PUBLIC_RAILING_BUILDER_URL || 'https://design.viewrail.com/';

// The 4 post product types that make up the railing builder's output catalog — every PDP whose
// product type is one of these is a candidate the builder can produce, so the callout belongs on
// all of them and nowhere else.
const RAILING_BUILDER_PRODUCT_TYPES: ProductTypeKey[] = [
  'cable-railing-post',
  'cable-railing-signature-post',
  'side-mount-post',
  'slim-side-mount-post',
];

/**
 * Resolves the Railing Designer builder URL for a post PDP, or `null` when the product's type
 * isn't one the builder produces (so the callout simply hides — a safe default).
 */
export const getRailingBuilderUrl = (productType: ProductTypeKey | undefined): string | null =>
  productType && RAILING_BUILDER_PRODUCT_TYPES.includes(productType) ? RAILING_BUILDER_URL : null;
